import React from "react";
import Styles from "./Styles.module.css";
import Slider5 from "./programsliders/Slider5";
import SkeletonDisplay from "../hooks/skeletonDisplay";

function  SocialJusticeInclusionandChildProtection() {
  return (
    <div>
      <div className={Styles.slider1}>
        <div className={Styles.mainContainer}>
          <SkeletonDisplay>
            <img src="/aboutus/aboutus.png" alt="Curd Africa" />
          </SkeletonDisplay>
          <button>Social Justice, Inclusion and Child Protection</button>
        </div>
      </div>
      <div style={{ margin: "0 auto" }}>
        <Slider5 />
      </div>
    </div>
  );
}

export default  SocialJusticeInclusionandChildProtection;
